import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { permPostOfferWorkflowFeatureKey, reducer } from './perm-post-offer-workflow.reducer';
import { PermPostOfferInterviewModalEffects } from './effects/perm-post-offer-interview-modal.effects';
import { PermPostOfferModalEffects } from './effects/perm-post-offer-modal.effects';
import { PermPostOfferCandidatesPageEffects } from './effects/perm-post-offer-candidates-page.effects';
import { PermPostOfferBillingUpdateEffects } from './effects/perm-post-offer-billing-update-modal.effects';
import { PermPostOfferConfirmNotStartingModalEffects } from './effects/perm-post-offer-confirm-not-starting-modal.effects';
import { EnvironmentProviders } from '@angular/core';

export const providePermPostOfferWorkflowStore = (): EnvironmentProviders[] => [
    provideState(permPostOfferWorkflowFeatureKey, reducer),
    provideEffects([
        PermPostOfferInterviewModalEffects,
        PermPostOfferModalEffects,
        PermPostOfferCandidatesPageEffects,
        PermPostOfferBillingUpdateEffects,
        PermPostOfferConfirmNotStartingModalEffects
    ])
];
